import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <CarouselSection />
        <TopicsSection />
        <IndexSection />
        <FaqSection />
        <RankingSection />
        <UpdatesSection />
        <ContactSection />
        <CardsSection />
        <CommentsSection />
        <AboutSection />
        <MediaSection />
        <FeaturesSection />
        <AppSection />
      </main>

      <Footer />
    </div>
  );
}